import { render, staticRenderFns } from "./TeacherSubjects.vue?vue&type=template&id=1bbcaa32&"
import script from "./TeacherSubjects.vue?vue&type=script&lang=js&"
export * from "./TeacherSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports